import { z } from 'zod';

/** `t` is the start position in whole seconds. */
export const transcriptSearchSchema = z.object({
  room: z.string().min(1).optional().catch(undefined),
  t: z.coerce.number().int().nonnegative().optional().catch(undefined),
});

export const toTimeParam = (ms: number) => String(Math.floor(ms / 1000));
